import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import {DownloadCloud} from 'lucide-react'
import './DownloadDataTable.css'
import {translate} from "react-i18next"
import {translateName} from "../../utils/i18n";
import _ from "lodash";

const getCellFormatter = (column, language, t) => {

    const getTranslation = rawValue => {
        if(column.translateName) return translateName(rawValue, language)
        if(column.translate) return  t(rawValue, { capitalize: true })
        return rawValue
    }
    switch (column.type) {
        case "object":
        case "dropdownObject":
            return p => {
                return column.display
                    ? p.value && getTranslation(p.value[column.display])
                    : p.value
            }
        case "objectArray":
        case "tags":
            return p => {
                const values = p.value

                return values && _.isArray(values) &&
                    values.map(object => {
                        const display = _.get(object, `${column.display}`)
                        return getTranslation(display)
                    }).join(', ')
            }
        case "status":
            return p => {
                const status = p.value
                return status?.value && getTranslation(status.value)
            }
        case "text":
        case "textarea":
            return p => getTranslation(p.value)
        default:
            return p => p.value
    }
}

const DownloadDataTable = ({ objects, filename, columns, user, exportTableObject, protectedExport, language, t = x => x }) => {
    const data = objects && objects.map(
        object => columns.reduce((acc, column) => {
            if(!column.dataGetter) return {
                ...acc,
                [column.path]: _.get(object, column.path)
            }
            let value = column.dataGetter(object)
            const cellFormatter = getCellFormatter(column, language, t)
            return {...acc, [column.path]: cellFormatter({value})}
        } , {})
    )

    const handleCLick = event => {
        exportTableObject(`${moment().format("YYYY-MM-DD_HH-mm-ss")}_${filename || 'data'}`, columns, data, user, protectedExport, language)
        event.preventDefault()
    }

    return (
        <button
            key="downloadDataTable"
            className="DataTable-Board-icon-container"
            onClick={handleCLick}
            title={t('exportDataTable')}
        >
            <DownloadCloud color="#9400d3ed" className="DataTable-Board-icon"/>
        </button>
    )
}

DownloadDataTable.propTypes = {
    filename: PropTypes.string,
    objects: PropTypes.array.isRequired,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            dataKey: PropTypes.string.isRequired,
            label: PropTypes.node.isRequired,
            cellDataGetter: PropTypes.func
        })
    ).isRequired
}

export default DownloadDataTable
